'use client';

import type { FC, JSX } from 'react';
import React from 'react';
import dynamic from 'next/dynamic';
const SherpaInfos = dynamic(() => import('@/components/SherpaInfos/SherpaInfos'));

const SherpaInfosWrapper: FC<{ sherpaCode: string }> = ({ sherpaCode }): JSX.Element => {
  return <SherpaInfos sherpaCode={sherpaCode} />;
};

export default SherpaInfosWrapper;
